import { render, staticRenderFns } from "./AnchorPageLabel.vue?vue&type=template&id=7076f968&scoped=true"
import script from "./AnchorPageLabel.vue?vue&type=script&lang=js"
export * from "./AnchorPageLabel.vue?vue&type=script&lang=js"
import style0 from "./AnchorPageLabel.vue?vue&type=style&index=0&id=7076f968&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7076f968",
  null
  
)

export default component.exports